import { createPublicClient, http } from "viem";
import { arbitrum, arbitrumSepolia, mainnet, plasma, sepolia } from "viem/chains";

import { getEnvChainById } from "./chains";

const ALCHEMY_API_KEY = process.env["ALCHEMY_API_KEY"];

function getUrl(chainName: string) {
  return `https://${chainName}.g.alchemy.com/v2/${ALCHEMY_API_KEY}`;
}

const USE_ANVIL = Boolean(process.env.NEXT_PUBLIC_USE_ANVIL);

export const RPC_URLS: Record<number, ReturnType<typeof getUrl>> = {
  [arbitrum.id]: USE_ANVIL ? "http://127.0.0.1:8545" : getUrl("arb-mainnet"),
  [mainnet.id]: USE_ANVIL ? "http://127.0.0.1:8546" : getUrl("eth-mainnet"),
  [plasma.id]: getUrl("plasma-mainnet"),
  /* testnets */
  [sepolia.id]: USE_ANVIL ? "http://127.0.0.1:8545" : getUrl("eth-sepolia"),
  [arbitrumSepolia.id]: USE_ANVIL ? "http://127.0.0.1:8546" : getUrl("arb-sepolia"),
};

export function rpcClient(chainId: number) {
  const chain = getEnvChainById(chainId);
  if (!chain) throw new Error(`Chain ${chainId} not supported`);
  return createPublicClient({ chain, transport: http(RPC_URLS[chain.id]) });
}
